/* 🤖 this file was generated by svg-to-ts */
export const matIconHdrStrong: {
  name: 'hdr-strong';
  data: string;
} = {
  name: 'hdr-strong',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`
};
